module.exports = __webpack_public_path__ + "static/media/quote-nav-5.2667799a.png";